module.exports = __webpack_public_path__ + "static/media/Card.7ae6a21a.png";